<template>
  <div id="slide-list">
    <b-modal
      size="xl"
      id="slide-list-modal"
      :noCloseOnBackdrop="true"
      :noCloseOnEsc="true"
      @shown="loadMore"
      :hide-header="true"
    >
      <vue-topprogress
        ref="topProgress"
        style="position: relative;right: 0px;height: 7px;"
      ></vue-topprogress>
      <div class="modal-body-content" v-on:click="closeListScreen(), (clicksOut = true)">
        <div id="plan1">
          <b-row class="my-2 d-flex justify-content-between">
            <b-col sm="8" v-has-permission="'show_blank_layout_action'">
              <slide-card
                id="emptyDisposition"
                :isEditable="false"
                :isHover="false"
                :isEmpty="true"
                :item="emptyDisposition"
                :isSelected="selecteIdSegment.includes(emptyDisposition.id)"
                @selected="addSegment(emptyDisposition)"
              ></slide-card>
            </b-col>
            <b-col sm="4">
              <b-input-group>
                <b-form-input
                  style="border-right:none;border-color: #7c7c7c;"
                  :placeholder="$t('placeholder.search')"
                  id="inputSearch"
                  v-on:keyup.enter="searchTitle()"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    v-on:click="searchTitle()"
                    style="border-left:none;background-color:#ffffff;color: #7c7c7c ;border-color: #7c7c7c"
                    variant="secondary"
                    ><i class="fa fa-search"></i
                  ></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col style="padding-left: 100px;">
              <div class="section-disposition section-disposition__title">
                <span>{{ $t('labels.models') }}</span>
              </div>
            </b-col>
            <b-col sm="1" v-has-permission="'add_segment_action'">
              <i
                id="fa-plus"
                @click="showSegmentModal"
                class="fa fa-plus-circle fa-2x"
                v-if="hideCancelButton"
                v-b-popover.hover.topleft="$t('labels.add_model')"
              ></i>
            </b-col>
          </b-row>
          <div class="slides-carousel" id="default-segment">
            <carousel
              navigation-prev-label="<span><img  src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC41MzEgNDQ0LjUzMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjUzMSA0NDQuNTMxOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTIxMy4xMywyMjIuNDA5TDM1MS44OCw4My42NTNjNy4wNS03LjA0MywxMC41NjctMTUuNjU3LDEwLjU2Ny0yNS44NDFjMC0xMC4xODMtMy41MTgtMTguNzkzLTEwLjU2Ny0yNS44MzUgICBsLTIxLjQwOS0yMS40MTZDMzIzLjQzMiwzLjUyMSwzMTQuODE3LDAsMzA0LjYzNywwcy0xOC43OTEsMy41MjEtMjUuODQxLDEwLjU2MUw5Mi42NDksMTk2LjQyNSAgIGMtNy4wNDQsNy4wNDMtMTAuNTY2LDE1LjY1Ni0xMC41NjYsMjUuODQxczMuNTIxLDE4Ljc5MSwxMC41NjYsMjUuODM3bDE4Ni4xNDYsMTg1Ljg2NGM3LjA1LDcuMDQzLDE1LjY2LDEwLjU2NCwyNS44NDEsMTAuNTY0ICAgczE4Ljc5NS0zLjUyMSwyNS44MzQtMTAuNTY0bDIxLjQwOS0yMS40MTJjNy4wNS03LjAzOSwxMC41NjctMTUuNjA0LDEwLjU2Ny0yNS42OTdjMC0xMC4wODUtMy41MTgtMTguNzQ2LTEwLjU2Ny0yNS45NzggICBMMjEzLjEzLDIyMi40MDl6IiBmaWxsPSIjYTZhNmE2Ii8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=='/></span>"
              navigation-next-label="<span><img src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC44MTkgNDQ0LjgxOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjgxOSA0NDQuODE5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTM1Mi4wMjUsMTk2LjcxMkwxNjUuODg0LDEwLjg0OEMxNTkuMDI5LDMuNjE1LDE1MC40NjksMCwxNDAuMTg3LDBjLTEwLjI4MiwwLTE4Ljg0MiwzLjYxOS0yNS42OTcsMTAuODQ4TDkyLjc5MiwzMi4yNjQgICBjLTcuMDQ0LDcuMDQzLTEwLjU2NiwxNS42MDQtMTAuNTY2LDI1LjY5MmMwLDkuODk3LDMuNTIxLDE4LjU2LDEwLjU2NiwyNS45ODFsMTM4Ljc1MywxMzguNDczTDkyLjc4NiwzNjEuMTY4ICAgYy03LjA0Miw3LjA0My0xMC41NjQsMTUuNjA0LTEwLjU2NCwyNS42OTNjMCw5Ljg5NiwzLjUyMSwxOC41NjIsMTAuNTY0LDI1Ljk4bDIxLjcsMjEuNDEzICAgYzcuMDQzLDcuMDQzLDE1LjYxMiwxMC41NjQsMjUuNjk3LDEwLjU2NGMxMC4wODksMCwxOC42NTYtMy41MjEsMjUuNjk3LTEwLjU2NGwxODYuMTQ1LTE4NS44NjQgICBjNy4wNDYtNy40MjMsMTAuNTcxLTE2LjA4NCwxMC41NzEtMjUuOTgxQzM2Mi41OTcsMjEyLjMyMSwzNTkuMDcxLDIwMy43NTUsMzUyLjAyNSwxOTYuNzEyeiIgZmlsbD0iI2EwYTBhMCIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo='/></span>"
              :mouse-drag="false"
              :navigation-enabled="true"
              :pagination-enabled="false"
              @pageChange="pageSegmentChanged('DefaultSegment')"
              :per-page-custom="[[320, 1], [576, 2], [768, 3], [992, 4], [1200, 4]]"
            >
              <slide v-for="item in DefaultSegments" :key="item.uid" class="one-disposition">
                <slide-card
                  :have-screen="item.screens.length > 1"
                  :Shot="item.screens[0] ? item.screens[0].screenShot : null"
                  :isHover="true"
                  :id="item.id"
                  :item="item"
                  :ModalSegment="true"
                  :title="item.title"
                  :itemsegment="item"
                  :isSelected="selecteIdSegment.includes(item.id)"
                  @selected="addSegment(item)"
                  @showSelect="showSelect(item)"
                ></slide-card>
              </slide>
            </carousel>
          </div>

          <div id="triangle" v-on:click="clicksOut = false">
            <b-collapse id="collapse-1" class="mt-2" v-model="showCollapse">
              <div class="p-3" style="min-height: 170px;">
                <carousel
                  navigation-prev-label="<span><img src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC41MzEgNDQ0LjUzMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjUzMSA0NDQuNTMxOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTIxMy4xMywyMjIuNDA5TDM1MS44OCw4My42NTNjNy4wNS03LjA0MywxMC41NjctMTUuNjU3LDEwLjU2Ny0yNS44NDFjMC0xMC4xODMtMy41MTgtMTguNzkzLTEwLjU2Ny0yNS44MzUgICBsLTIxLjQwOS0yMS40MTZDMzIzLjQzMiwzLjUyMSwzMTQuODE3LDAsMzA0LjYzNywwcy0xOC43OTEsMy41MjEtMjUuODQxLDEwLjU2MUw5Mi42NDksMTk2LjQyNSAgIGMtNy4wNDQsNy4wNDMtMTAuNTY2LDE1LjY1Ni0xMC41NjYsMjUuODQxczMuNTIxLDE4Ljc5MSwxMC41NjYsMjUuODM3bDE4Ni4xNDYsMTg1Ljg2NGM3LjA1LDcuMDQzLDE1LjY2LDEwLjU2NCwyNS44NDEsMTAuNTY0ICAgczE4Ljc5NS0zLjUyMSwyNS44MzQtMTAuNTY0bDIxLjQwOS0yMS40MTJjNy4wNS03LjAzOSwxMC41NjctMTUuNjA0LDEwLjU2Ny0yNS42OTdjMC0xMC4wODUtMy41MTgtMTguNzQ2LTEwLjU2Ny0yNS45NzggICBMMjEzLjEzLDIyMi40MDl6IiBmaWxsPSIjYTZhNmE2Ii8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=='/></span>"
                  navigation-next-label="<span><img src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC44MTkgNDQ0LjgxOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjgxOSA0NDQuODE5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTM1Mi4wMjUsMTk2LjcxMkwxNjUuODg0LDEwLjg0OEMxNTkuMDI5LDMuNjE1LDE1MC40NjksMCwxNDAuMTg3LDBjLTEwLjI4MiwwLTE4Ljg0MiwzLjYxOS0yNS42OTcsMTAuODQ4TDkyLjc5MiwzMi4yNjQgICBjLTcuMDQ0LDcuMDQzLTEwLjU2NiwxNS42MDQtMTAuNTY2LDI1LjY5MmMwLDkuODk3LDMuNTIxLDE4LjU2LDEwLjU2NiwyNS45ODFsMTM4Ljc1MywxMzguNDczTDkyLjc4NiwzNjEuMTY4ICAgYy03LjA0Miw3LjA0My0xMC41NjQsMTUuNjA0LTEwLjU2NCwyNS42OTNjMCw5Ljg5NiwzLjUyMSwxOC41NjIsMTAuNTY0LDI1Ljk4bDIxLjcsMjEuNDEzICAgYzcuMDQzLDcuMDQzLDE1LjYxMiwxMC41NjQsMjUuNjk3LDEwLjU2NGMxMC4wODksMCwxOC42NTYtMy41MjEsMjUuNjk3LTEwLjU2NGwxODYuMTQ1LTE4NS44NjQgICBjNy4wNDYtNy40MjMsMTAuNTcxLTE2LjA4NCwxMC41NzEtMjUuOTgxQzM2Mi41OTcsMjEyLjMyMSwzNTkuMDcxLDIwMy43NTUsMzUyLjAyNSwxOTYuNzEyeiIgZmlsbD0iI2EwYTBhMCIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo='/></span>"
                  :mouse-drag="false"
                  :navigation-enabled="true"
                  :pagination-enabled="false"
                  @pageChange="pageSegmentChanged('DefaultSegment')"
                  :per-page-custom="[[320, 1], [576, 2], [768, 3], [992, 4], [1200, 4]]"
                >
                  <slide
                    v-for="item in getScreens(currentSegment.screens)"
                    :key="item.uid"
                    class="one-screen"
                  >
                    <slide-card
                      v-bind:style="{ cursor: 'default' }"
                      v-if="!item.type === 'BlankSlide'"
                      :isHover="false"
                      :ModalSegment="true"
                      :item="item"
                      :title="item.title"
                      :Shot="item.screenShot"
                    ></slide-card>
                  </slide>
                </carousel>
              </div>
            </b-collapse>
          </div>
          <div v-show="segments.length !== 0" class="section-screen section-screen__title">
            <span>{{ $t('labels.recent') }}</span>
          </div>
          <div class="slides-carousel" id="segment-template" v-show="segments.length !== 0">
            <carousel
              navigation-prev-label="<span><img src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC41MzEgNDQ0LjUzMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjUzMSA0NDQuNTMxOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTIxMy4xMywyMjIuNDA5TDM1MS44OCw4My42NTNjNy4wNS03LjA0MywxMC41NjctMTUuNjU3LDEwLjU2Ny0yNS44NDFjMC0xMC4xODMtMy41MTgtMTguNzkzLTEwLjU2Ny0yNS44MzUgICBsLTIxLjQwOS0yMS40MTZDMzIzLjQzMiwzLjUyMSwzMTQuODE3LDAsMzA0LjYzNywwcy0xOC43OTEsMy41MjEtMjUuODQxLDEwLjU2MUw5Mi42NDksMTk2LjQyNSAgIGMtNy4wNDQsNy4wNDMtMTAuNTY2LDE1LjY1Ni0xMC41NjYsMjUuODQxczMuNTIxLDE4Ljc5MSwxMC41NjYsMjUuODM3bDE4Ni4xNDYsMTg1Ljg2NGM3LjA1LDcuMDQzLDE1LjY2LDEwLjU2NCwyNS44NDEsMTAuNTY0ICAgczE4Ljc5NS0zLjUyMSwyNS44MzQtMTAuNTY0bDIxLjQwOS0yMS40MTJjNy4wNS03LjAzOSwxMC41NjctMTUuNjA0LDEwLjU2Ny0yNS42OTdjMC0xMC4wODUtMy41MTgtMTguNzQ2LTEwLjU2Ny0yNS45NzggICBMMjEzLjEzLDIyMi40MDl6IiBmaWxsPSIjYTZhNmE2Ii8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=='/></span>"
              navigation-next-label="<span><img src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC44MTkgNDQ0LjgxOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjgxOSA0NDQuODE5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTM1Mi4wMjUsMTk2LjcxMkwxNjUuODg0LDEwLjg0OEMxNTkuMDI5LDMuNjE1LDE1MC40NjksMCwxNDAuMTg3LDBjLTEwLjI4MiwwLTE4Ljg0MiwzLjYxOS0yNS42OTcsMTAuODQ4TDkyLjc5MiwzMi4yNjQgICBjLTcuMDQ0LDcuMDQzLTEwLjU2NiwxNS42MDQtMTAuNTY2LDI1LjY5MmMwLDkuODk3LDMuNTIxLDE4LjU2LDEwLjU2NiwyNS45ODFsMTM4Ljc1MywxMzguNDczTDkyLjc4NiwzNjEuMTY4ICAgYy03LjA0Miw3LjA0My0xMC41NjQsMTUuNjA0LTEwLjU2NCwyNS42OTNjMCw5Ljg5NiwzLjUyMSwxOC41NjIsMTAuNTY0LDI1Ljk4bDIxLjcsMjEuNDEzICAgYzcuMDQzLDcuMDQzLDE1LjYxMiwxMC41NjQsMjUuNjk3LDEwLjU2NGMxMC4wODksMCwxOC42NTYtMy41MjEsMjUuNjk3LTEwLjU2NGwxODYuMTQ1LTE4NS44NjQgICBjNy4wNDYtNy40MjMsMTAuNTcxLTE2LjA4NCwxMC41NzEtMjUuOTgxQzM2Mi41OTcsMjEyLjMyMSwzNTkuMDcxLDIwMy43NTUsMzUyLjAyNSwxOTYuNzEyeiIgZmlsbD0iI2EwYTBhMCIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo='/></span>"
              :mouse-drag="false"
              :navigation-enabled="true"
              :pagination-enabled="false"
              @pageChange="pageSegmentChanged('Segment')"
              :per-page-custom="[[320, 1], [576, 2], [768, 3], [992, 4], [1200, 4]]"
            >
              <slide v-for="item in segments" :key="item.id" class="one-screen">
                <slide-card
                  :ModalSegment="true"
                  :isHover="true"
                  :id="item.id"
                  :have-screen="item.screens.length > 1"
                  :Shot="item.screens[0] ? item.screens[0].screenShot : null"
                  :item="item"
                  :title="item.title"
                  :isCollapse2="true"
                  :isSelected="selecteIdSegment.includes(item.id)"
                  @selected="addSegment(item)"
                  @showSelect2="showSelect2(item)"
                ></slide-card>
              </slide>
            </carousel>
          </div>

          <div id="triangle2" v-on:click="clicksOut = false">
            <b-collapse id="collapse-2" class="mt-2" v-model="showCollapse2">
              <div class="p-3" style="min-height: 170px;">
                <carousel
                  navigation-prev-label="<span><img src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC41MzEgNDQ0LjUzMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjUzMSA0NDQuNTMxOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTIxMy4xMywyMjIuNDA5TDM1MS44OCw4My42NTNjNy4wNS03LjA0MywxMC41NjctMTUuNjU3LDEwLjU2Ny0yNS44NDFjMC0xMC4xODMtMy41MTgtMTguNzkzLTEwLjU2Ny0yNS44MzUgICBsLTIxLjQwOS0yMS40MTZDMzIzLjQzMiwzLjUyMSwzMTQuODE3LDAsMzA0LjYzNywwcy0xOC43OTEsMy41MjEtMjUuODQxLDEwLjU2MUw5Mi42NDksMTk2LjQyNSAgIGMtNy4wNDQsNy4wNDMtMTAuNTY2LDE1LjY1Ni0xMC41NjYsMjUuODQxczMuNTIxLDE4Ljc5MSwxMC41NjYsMjUuODM3bDE4Ni4xNDYsMTg1Ljg2NGM3LjA1LDcuMDQzLDE1LjY2LDEwLjU2NCwyNS44NDEsMTAuNTY0ICAgczE4Ljc5NS0zLjUyMSwyNS44MzQtMTAuNTY0bDIxLjQwOS0yMS40MTJjNy4wNS03LjAzOSwxMC41NjctMTUuNjA0LDEwLjU2Ny0yNS42OTdjMC0xMC4wODUtMy41MTgtMTguNzQ2LTEwLjU2Ny0yNS45NzggICBMMjEzLjEzLDIyMi40MDl6IiBmaWxsPSIjYTZhNmE2Ii8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=='/></span>"
                  navigation-next-label="<span><img src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC44MTkgNDQ0LjgxOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjgxOSA0NDQuODE5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTM1Mi4wMjUsMTk2LjcxMkwxNjUuODg0LDEwLjg0OEMxNTkuMDI5LDMuNjE1LDE1MC40NjksMCwxNDAuMTg3LDBjLTEwLjI4MiwwLTE4Ljg0MiwzLjYxOS0yNS42OTcsMTAuODQ4TDkyLjc5MiwzMi4yNjQgICBjLTcuMDQ0LDcuMDQzLTEwLjU2NiwxNS42MDQtMTAuNTY2LDI1LjY5MmMwLDkuODk3LDMuNTIxLDE4LjU2LDEwLjU2NiwyNS45ODFsMTM4Ljc1MywxMzguNDczTDkyLjc4NiwzNjEuMTY4ICAgYy03LjA0Miw3LjA0My0xMC41NjQsMTUuNjA0LTEwLjU2NCwyNS42OTNjMCw5Ljg5NiwzLjUyMSwxOC41NjIsMTAuNTY0LDI1Ljk4bDIxLjcsMjEuNDEzICAgYzcuMDQzLDcuMDQzLDE1LjYxMiwxMC41NjQsMjUuNjk3LDEwLjU2NGMxMC4wODksMCwxOC42NTYtMy41MjEsMjUuNjk3LTEwLjU2NGwxODYuMTQ1LTE4NS44NjQgICBjNy4wNDYtNy40MjMsMTAuNTcxLTE2LjA4NCwxMC41NzEtMjUuOTgxQzM2Mi41OTcsMjEyLjMyMSwzNTkuMDcxLDIwMy43NTUsMzUyLjAyNSwxOTYuNzEyeiIgZmlsbD0iI2EwYTBhMCIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo='/></span>"
                  :mouse-drag="false"
                  :navigation-enabled="true"
                  :pagination-enabled="false"
                  @pageChange="pageSegmentChanged('Segment')"
                  :per-page-custom="[[320, 1], [576, 2], [768, 3], [992, 4], [1200, 4]]"
                >
                  <slide
                    v-for="item in getScreens(currentSegment.screens)"
                    :key="item.uid"
                    class="one-screen"
                  >
                    <slide-card
                      v-bind:style="{ cursor: 'default' }"
                      v-if="!item.type === 'BlankSlide'"
                      :isHover="false"
                      :ModalSegment="true"
                      :item="item"
                      :title="item.title"
                      :Shot="item.screenShot"
                    ></slide-card>
                  </slide>
                </carousel>
              </div>
            </b-collapse>
          </div>
        </div>
        <div id="plan2" v-show="navparam" v-on:click="clicksOut = false">
          <div id="content-plan2">
            <b-row class="my-2 d-flex justify-content-between">
              <b-col>
                <b-form-group
                  class="text-left"
                  id="input-group-title"
                  :label="$t('labels.title')"
                  label-for="input-titre"
                >
                  <b-form-input
                    id="input-titre"
                    :state="stateTitle"
                    v-model="titleTemplate"
                    required
                    :placeholder="$t('placeholder.title')"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col v-has-permission="'use_ligne_template_action'">
                <b-form-group
                  class="text-left"
                  id="input-group-title"
                  :label="$t('labels.ligne')"
                  label-for="input-titre"
                >
                  <b-form-select
                    required
                    :state="stateLigne"
                    id="input-ligne"
                    class="mb-3"
                    v-model="ligneTemplate"
                  >
                    <option
                      v-for="option in options"
                      :value="option.name"
                      :key="option.value"
                      v-bind:value="option.value"
                    >
                      {{ option.name }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="4" v-has-permission="'initialize_duration_template_action'">
                <b-form-group
                  class="text-left"
                  id="input-group-time"
                  :label="$t('labels.duration')"
                  label-for="input-time"
                >
                  <b-form-input
                    class="input-time"
                    :state="stateDuration"
                    v-model="durationTemplate"
                    id="input-time"
                    type="text"
                    step="2"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="text-right">
                <button
                  :class="['btn btn-primary']"
                  v-on:click="onNav(), changeStyleOff()"
                  v-if="navparam"
                >
                  <i :class="['fa fa-arrow-right']"></i> {{ $t('button.next') }}
                </button>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
      <template v-slot:modal-footer>
        <button :class="['btn btn-link']" @click="cancel()" v-if="!hideCancelButton">
          {{ $t('button.cancel') }}
        </button>
        <button
          :class="['btn btn-primary']"
          v-on:click="onNav(), changeStyleOn()"
          id="btn-next"
          v-if="hideCancelButton && !navparam"
        >
          <i :class="['fa fa-arrow-left']"></i> {{ $t('button.back') }}
        </button>
        <button
          :class="['btn btn-primary']"
          v-on:click="confirm()"
          :disabled="disabledConfirmButton"
          v-if="!hideCancelButton"
        >
          <i :class="['fa fa-check']"></i> {{ $t('button.confirm') }}
        </button>
        <b-button
          v-if="hideCancelButton && !navparam"
          id="btn-finish"
          type="submit"
          variant="primary"
          @click="confirm"
          :disabled="confirmButtonDisabled"
        >
          <i class="fa fa-check"></i> {{ $t('button.finish') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import en from '../../i18n/en_US';
import fr from '../../i18n/fr_FR';
import SlideCard from './SlideCard';
import mixin from '../../mixins/Mixin.js';
import { Carousel, Slide } from 'vue-carousel';
import mixinGrapesHelpers from '../../mixins/GrapesMixinHelpers';
import SegmentList from './SegmentList.vue';
import { vueTopprogress } from 'vue-top-progress';
import HasPermission from '../../core/directives/HasPermission.js';
import * as durationHelper from '../../helpers/duration-handler';

export default {
  name: 'SlideList',
  mixins: [mixin, mixinGrapesHelpers],
  directives: {
    HasPermission,
  },
  data() {
    return {
      options: [],
      ligneTemplate: [],
      clicksOut: true,
      showCollapse: false,
      showCollapse2: false,
      navparam: true,
      selectedTab: '',
      infiniteState: null,
      selectedIds: [],
      selecteIdSegment: [],

      titleTemplate: this.$t('template.new_template'),
      total: 0,
      hideCancelButton: true,
      disabledConfirmButton: true,
      duration: 59,
    };
  },
  components: {
    vueTopprogress,
    SlideCard,
    Carousel,
    Slide,
    SegmentList,
  },
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  watch: {
    // Problème 11 : même défaut que dans ModuleList — sans cette hydratation,
    // confirm() renvoie « Nouveau programme » et écrase le nom du programme.
    'template.title': {
      immediate: true,
      handler(title) {
        if (title) this.titleTemplate = title;
      },
    },
  },
  computed: {
    ...mapGetters({
      //recentsSegment:'segments/getAllSegments',
      screens: 'slides/getAllScreens',
      currentSlide: 'slides/getCurrent',
      dispositions: 'slides/getAllDispositions',
      all: 'segments/getSegments',
      segments: 'segments/getAllSegments',
      SegmentsFiltredByTitle: 'segment/getFilterSegments',
      DefaultSegments: 'segments/getAllDefaultSegments',
      isLoading: 'slides/getLoading',
      isEndReached: 'slides/getEndReached',
      selected: 'slides/getSelected',
      selectedSegments: 'segments/getSelectedSegments',
      currentSegment: 'segments/getCurrent',
      isSelected: 'slides/isSelected',
      firstSelectedSegment: 'segments/getLastSegmentById',
      showIconSave: 'common/getShowIconSave',
      paramsClient: 'getParamsClients',
      hasPermission: 'hasPermission',
      totalDurationSegments: 'segments/getAllSegmentsDuration',
      template: 'slides/getTemplate',
    }),
    confirmButtonDisabled() {
      return this.selected.length === 0 && this.selectedSegments.length === 0;
    },
    stateTitle() {
      var state = this.titleTemplate.length >= 1 ? true : false;
      if (state) return null;
      else return state;
    },
    stateLigne() {
      var state = this.ligneTemplate.length >= 1 ? true : false;
      if (state) return null;
      else return state;
    },
    stateDuration() {
      if (
        this.durationTemplate === '00:00:00' ||
        this.durationTemplate === '' ||
        this.durationTemplate === '00:00'
      )
        return false;
      else return null;
    },
    durationTemplate: {
      get: function() {
        let value = this.duration;
        let hours = Math.floor(value / 3600);
        value %= 3600;
        let minutes = Math.floor(value / 60);
        let seconds = value % 60;
        let addZero = v => (v < 10 ? '0' + v : v);
        let t = [];

        t.push(addZero(hours));
        t.push(addZero(minutes));
        t.push(addZero(seconds));

        return t.join(':');
      },
      set: function(value) {
        this.duration = value
          .split(':')
          .reverse()
          .reduce((prev, curr, i) => prev + curr * Math.pow(60, i), 0);
      },
    },
    emptyDisposition() {
      var disposition = {
        id: 0,
        type: 'Segment',
        title: this.$t('disposition.empty'),
        duration: durationHelper.totalSegmentDuration(),
        screens: [
          {
            id: 0,
            title: this.$t('screens.empty'),
            type: 'screen',
            options: { duration: durationHelper.totalSegmentDuration() },
            assets: '',
            components: '',
            css: '',
            html: '',
            styles: '',
            transition: {
              in: '',
              out: '',
            },
            screenShot:
              'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJAQMAAAAB5D5xAAAABlBMVEXs7vHs7/Hee24nAAAAFUlEQVQI12P4/58BiGrB5D8wCUX/AOfxEWuWlIcVAAAAAElFTkSuQmCC',
          },
        ],
      };
      return disposition;
    },
  },
  methods: {
    ...mapActions('slides', [
      'paginate',
      'selectSlide',
      'setCurrentSlide',
      'removeLastSlideById',
      'updateSlide',
      'fetch',
      'setTemplate',
    ]),

    ...mapActions('segments', [
      'getSegments',
      'paginatesegment',
      'selectSegment',
      'setCurrentSegment',
      'removeLastSegmentById',
      'updateSegment',
      'setTitle',
      'resetPage',
      'setSegments',
      'setNbrCall',
      'updateSlideInsideSegment',
    ]),
    ...mapActions('common', ['setShowIconSave']),
    ...mapActions(['setRoute']),

    optionsLine() {
      if (this.paramsClient.default_line) {
        this.options = this.paramsClient.default_line;
        this.ligneTemplate = this.options[0].value;
      }
    },

    showSegmentModal() {
      this.$router.push({ name: 'segment' });
      this.setRoute('segment');
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.innerHTML = "<span style='font-family:RobotoUep!important;'>" + this.$t('template.save_and_exit')+"</span>";
      }
      this.cancel();
      //réinitialiser Modal Listsegment
      eventHub.$emit('resetModalSegmentList');
      this.$root.$emit('bv::show::modal', 'segment-list-modal', '#btnShow');
    },
    loadMore() {
      this.isShown = true;
    },
    showTab(tab) {
      this.selectedTab = tab;
    },
    select(item) {
      let selected = JSON.parse(JSON.stringify(item));
      if (this.selectedIds.includes(selected.id)) {
        this.selectedIds = this.selectedIds.filter(i => i !== selected.id);
        this.removeLastSlideById(selected.id);
      } else {
        this.selectedIds.push(selected.id);
        this.selectSlide(selected);
      }
    },
    addSegment(item) {
      // this.setCurrentSegment(item);
      let selectedSegment = JSON.parse(JSON.stringify(item));

      if (this.selecteIdSegment.includes(selectedSegment.id)) {
        this.selecteIdSegment = this.selecteIdSegment.filter(i => i !== selectedSegment.id);
        this.removeLastSegmentById(selectedSegment.id);
      } else {
        this.disabledConfirmButton = false;
        this.selecteIdSegment.push(selectedSegment.id);
        this.selectSegment(selectedSegment);
      }
      if (this.selecteIdSegment.length < 1) {
        this.disabledConfirmButton = true;
      }
    },
    showSelect(item) {
      this.showCollapse = true;
      this.showCollapse2 = false;
      this.setCurrentSegment(item);
      var px = document.getElementById(item.id).offsetLeft + 150;
      var defaultSegment = document.querySelector('#default-segment .VueCarousel-inner').style
        .transform;
      //mixin code
      this.triangleStyle('#triangle', defaultSegment, px);
    },
    showSelect2(item) {
      this.showCollapse2 = true;
      this.showCollapse = false;
      this.setCurrentSegment(item);
      var px = document.getElementById(item.id).offsetLeft + 150;
      var segmentTemplate = document.querySelector('#segment-template .VueCarousel-inner').style
        .transform;
      //mixin code
      this.triangleStyle('#triangle2', segmentTemplate, px);
    },
    /*confirm() {
      const psElement = document.getElementById('ps-slide-wrapper');
      const DraggableElement = document.getElementById('draggable-wrapper');
      psElement.scrollLeft = DraggableElement.offsetWidth;
      this.selectFirstSlide();
      this.selected.map(s => (this.total += s.options.duration));

      this.setTotalDuration(this.total);
      this.selectedIds = [];
      const template = {
        title: this.titleTemplate !== '' ? this.titleTemplate : this.$t('template.new_template'),
        duration: this.durationTemplate
      };

      this.setTemplate(template);
      this.selecteIdSegment = [];
      this.$root.$emit('bv::hide::modal', 'slide-list-modal');
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
        this.setShowIconSave(true);
        if (this.$route.name === 'segment') {
          iconSave.classList.add('only-save');
        }
      }
    }*/
    confirm() {
      const editor = grapesjsEMP.editors[0];
      if (this.stateTitle == null && this.stateDuration == null) {
        const psElement = document.getElementById('ps-slide-wrapper');
        const DraggableElement = document.getElementById('draggable-wrapper');
        psElement.scrollLeft = DraggableElement.offsetWidth;
        this.selectFirstSlide();

        let durationT = '';
        if (this.$route.name === 'edit') {
          durationT = this.template.duration;
        } else durationT = this.durationTemplate;

        // Durée totale des écrans
        this.total = 0;
        this.selectedSegments.map(s => (this.total += s.duration));
        this.selectedIds = [];
        const template = {
          title: this.titleTemplate !== '' ? this.titleTemplate : this.$t('template.new_template'),
          ligne: this.ligneTemplate !== [] ? this.ligneTemplate : this.$t('template.new_ligne'),
          duration: durationT,
        };

        this.setTemplate(template);
        this.selecteIdSegment = [];
        this.$root.$emit('bv::hide::modal', 'slide-list-modal');
        var iconSave = document.querySelector('.icon-save');
        if (iconSave) {
          iconSave.classList.add('icon-selected');
          iconSave.innerText = '';

          this.setShowIconSave(true);
        }

        if (
          this.paramsClient.display_default_blocks &&
          Object.keys(this.paramsClient.display_default_blocks).length > 0 &&
          this.paramsClient.modules.show_list_block_action
        ) {
          const blocks = document.querySelector(
            '#gjs .gjs-pn-buttons .fa-th-large:not(.gjs-pn-active)',
          );
          if (blocks) {
            blocks.click();
          }
        }
        this.onNav();
        this.changeStyleOff();
      }
      this.setNbrCall();
      this.setNoAutoplayVideo(editor);

      let videoPlayers = ['player', 'playlist'];
      videoPlayers.forEach(player => {
        this.setPausedVideo(player);
      });
    },
    selectFirstSlide() {
      const lastSlide = {
        uid: this.currentSlide.uid,
        components: localStorage.getItem('gjs-components'),
        js: localStorage.getItem('gjs-js'),
        html: localStorage.getItem('gjs-html'),
        css: this.sanitizeCSS(localStorage.getItem('gjs-css')),
        styles: localStorage.getItem('gjs-styles'),
      };

      this.updateSlideInsideSegment(lastSlide);
      this.generateSlideThmbnail(lastSlide.uid);

      const segment = this.firstSelectedSegment(this.selecteIdSegment[0]);
      this.setCurrentSegment(segment);
      this.setCurrentSlide(segment.screens.filter(s => s.type !== 'startGeneric')[0]);

      this.$root.$emit('updateCanvasContent');
    },

    cancel() {
      this.selecteIdSegment.forEach(id => {
        this.removeLastSegmentById(id);
      });
      this.selecteIdSegment = [];
      this.$root.$emit('bv::hide::modal', 'slide-list-modal');
    },
    pageChanged(selectedTab) {
      const modal = document.getElementById('slide-list-modal');
      if (!modal || modal.style.display === 'none' || this.isLoading) {
        return;
      }
      let length;
      if (selectedTab === 'Screen') {
        length = this.screens.length;
      }
      if (selectedTab === 'dispositions') {
        length = this.dispositions.length;
      }
      if (this.isEndReached(selectedTab) || !this.isShown) {
        return;
      }
      // this.paginate(selectedTab);
    },
    pageSegmentChanged(selectedTab) {
      const modal = document.getElementById('slide-list-modal');
      if (!modal || modal.style.display === 'none' || this.isLoading) {
        return;
      }
      let length;

      if (selectedTab === 'Segment') {
        length = this.segments.length;
      }
      if (selectedTab === 'DefaultSegments') {
        length = this.DefaultSegments.length;
      }
      if (this.isEndReached(selectedTab) || !this.isShown) {
        return;
      }
      this.paginatesegment(selectedTab);
    },
    onNav() {
      this.navparam = !this.navparam;
    },
    changeStyleOn() {
      var style = document.createElement('style');
      style.innerHTML = `
        #plan2 {z-index: 9999;position: absolute;background-color: rgba(255, 255, 255, 0.85);top:0; left:0; width: 100%;height: 100%;}
        #plan1 {z-index: 1; filter: blur(4px);}
        #btn-next {visibility:hidden;}
        #btn-finish {visibility:hidden;}
       `;
      document.head.appendChild(style);
    },
    changeStyleOff() {
      var style = document.createElement('style');
      style.innerHTML = `
        #plan1 {z-index: 1;
        filter: blur(0px);}
        #btn-next {visibility:visible;}
        #btn-finish {visibility:visible;}
       `;
      document.head.appendChild(style);
    },
    closeListScreen() {
      if (this.clicksOut) {
        this.showCollapse = false;
        this.showCollapse2 = false;
      }
    },
    searchTitle() {
      this.$refs.topProgress.start();

      var title = document.getElementById('inputSearch').value;
      this.setSegments([]);
      this.setTitle(title);
      this.resetPage('Segment');
      this.paginatesegment('Segment');
      this.resetPage('DefaultSegment');
      this.paginatesegment('DefaultSegment');
    },
    getScreens(screens) {
      return screens && screens.filter(s => !s.type.toLowerCase().includes('generic'));
    },
    setButtonCancel(cancel) {
      this.hideCancelButton = cancel;
    },
  },
  async mounted() {
    //this.paginate('Disposition');
    //this.paginate('Screen');
    this.paginatesegment('Segment');
    this.paginatesegment('DefaultSegment');

    this.changeStyleOn();

    eventHub.$on('hideModalTitleSegment', val => {
      this.navparam = !val;
      this.selecteIdSegment = [];
      this.hideCancelButton = !val;
      this.disabledConfirmButton = val;
      this.changeStyleOff();
    });

    this.optionsLine();
  },
  created() {
    let self = this;
    eventHub.$on('stopProgress', val => {
      self.$refs.topProgress.done();
    });
    eventHub.$on('saveSelect', this.addSegment);
    eventHub.$on('hideCancelButton', this.setButtonCancel);
  },
};
</script>

<style lang="scss">
$primar-color: #2196f3;

#collapse-1 {
  background-color: rgba(124, 124, 124, 0.38);
}
#collapse-2 {
  background-color: rgba(124, 124, 124, 0.38);
}

.top-progress .peg {
  display: none !important;
}

#content-plan2 {
  margin-left: 30px;
  margin-right: 30px;
  padding-top: 200px;
}
#fa-plus {
  color: #2196f3;
  cursor: pointer;
}

#editor .form-control .input-time {
  color: #2196f3;
}
#emptyDisposition {
  border-style: solid;
  border-radius: 6px;
  border-color: #2196f3;
  text-align: center;
  .title-screen__span {
    color: #2196f3;
    text-align: center;
  }
  .title-screen {
    width: 100%;
    height: 100%;
    position: absolute;
    font-weight: bold;
    text-align: center;
    padding: 0.5em;
    //color: #ffffff;
    background: #ffffff;
    height: 8em;
    padding-top: 50px;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
  }
  &:hover {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16), 2px 4px 6px rgba(0, 0, 0, 0.23);
    .edit-title-btn {
      opacity: 1 !important;
      visibility: visible !important;
      background: rgba(26, 147, 240, 0.6);
    }
    .title-screen {
      background: rgba(26, 147, 240, 0.6);
      height: 10em;
    }
    .title-screen__span {
      color: #ffffff;
    }
  }
  &.selected {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16), 2px 4px 6px rgba(0, 0, 0, 0.23);
    .buttons-container {
      opacity: 0;
      visibility: hidden;
    }
    &:before {
      background: rgba(26, 147, 240, 0.6);
    }
    .title-screen {
      background: none;
    }
    .tick-img {
      display: block;
    }
    .title-screen__span {
      color: #ffffff;
    }
  }
}

#slide-list {
  .modal-body-content {
    padding: 20px 30px;
  }
  .modal-body {
    padding: 0;
  }
  .slide {
    margin: 5px !important;
    max-width: 223px;
  }
  .VueCarousel-navigation .VueCarousel-navigation-button :focus {
    outline: none !important;
  }
  .section-screen,
  .section-disposition {
    margin: 1em 0 1em 0;
    &__title {
      line-height: 0.5;
      text-align: center;
      .add-segment {
        padding: 0;
      }
    }
    &__title span {
      display: inline-block;
      position: relative;
      /*text-transform: uppercase;*/
      font-size: 1.2em;
      font-weight: 400;
    }
    &__title span:before,
    &__title span:after {
      content: '';
      position: absolute;
      height: 5px;
      border-bottom: 1px solid #f0f0f0;
      top: 0;
      width: 410px;
    }
    &__title span:before {
      right: 100%;
      margin-right: 15px;
    }
    &__title span:after {
      left: 100%;
      margin-left: 10px;
    }
  }
  //0 left 1 center
  .VueCarousel-slide {
    flex: 0 0 25%;
  }
  #slide-list-modal {
    color: #707070;
    &___BV_modal_header_ {
      background-color: $primar-color;
      color: #ffffff;
      border-radius: 0;
      .title {
        margin-bottom: 0;
      }
    }
    &___BV_modal_content_ {
      border-radius: 0;
    }
    &___BV_modal_footer_ {
      .btn-primary {
        background-color: $primar-color;
        border-color: $primar-color;
        border-radius: 0.1rem;
      }
      .btn-link {
        &:hover,
        &:focus {
          text-decoration: none;
        }
      }
    }
    .modal-dialog.modal-xl {
      max-width: 1000px !important;
    }
  }
}
.VueCarousel-navigation-button:focus {
  outline: none !important;
}
.VueCarousel-slide {
  visibility: visible;
  flex-basis: 100%;
  width: 100%;
}
.displayButton {
  display: none;
}
</style>



// WEBPACK FOOTER //
// SlideList.vue?7e5dd7c7